var version = {
    "name":      "dativery",
    "buildDateCode": "20260115-105736",
    "buildDate": "Thu Jan 15 2026 10:57:36 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260115-105736",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;